import React, {Component} from 'react';
import './DailySafeDetailsView.css';

class DailySafeDetailsView extends Component {

  constructor(props){
    super(props);
  }

  componentDidMount(){
    if (window.parent !== window) {
      window.parent.onLabelLoaded(document);
    }
  }


  render() {

    return (
      <div id="printDailySafeDetailsDiv">
      </div>
    );
  }
}

export default DailySafeDetailsView;



// WEBPACK FOOTER //
// ./src/components/safes/planning/DailySafeDetailsView.js